var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 23,
    viewBox: "0 0 43 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.167C24.0585 19.167 24.917 20.0254 24.917 21.084C24.9168 22.1424 24.0584 23 23 23H19.167C18.1086 23 17.2502 22.1424 17.25 21.084C17.25 20.0254 18.1084 19.167 19.167 19.167H23Z",
    fill: "#0E86D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.584 9.58398C33.6423 9.58416 34.4998 10.4417 34.5 11.5C34.5 12.5584 33.6424 13.4168 32.584 13.417H9.58398C8.52544 13.417 7.66699 12.5585 7.66699 11.5C7.66717 10.4416 8.52555 9.58398 9.58398 9.58398H32.584Z",
    fill: "#0E86D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 0C41.3085 0 42.167 0.858446 42.167 1.91699C42.167 2.97554 41.3085 3.83398 40.25 3.83398H1.91699C0.858446 3.83398 0 2.97554 0 1.91699C0 0.858446 0.858446 0 1.91699 0H40.25Z",
    fill: "#0E86D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterA);
export default __webpack_public_path__ + "static/media/FilterA.789224e54475489ed7f94c3a1de6f921.svg";
export { ForwardRef as ReactComponent };